<template>
  <v-card :href="addr" target="_blank"
    :class="$vuetify.breakpoint.mdAndUp? 'mb-3 mr-3 pb-0 fill-height' :'mr-3 pb-0' " width="100%" min-width="210"  
  > 
    <v-row no-gutters> 
      <v-col cols="4" md="12">
        <v-img 
          :height="$vuetify.breakpoint.mdAndUp? 180 : $vuetify.breakpoint.sm? 150 : 200" 
          :src="require('../assets/' + thumbnail)" 
          :gradient="gradientStyle"
          class="tool-preview"
          :alt="title"
        >
        </v-img>
      </v-col>
      <v-col cols="8" md="12">
        <v-card-title class="mb-0 pt-2 pt-sm-3 pb-0" >
          <h4 class="wdgt-title tool-title" v-html="title"></h4>
        </v-card-title>

        <v-card-text class="py-1 pt-md-0 pb-md-1">
          <p class="infowdgtxt darkgrey-text mb-0" v-html="content"></p> <!--cannot fix the p margin-bottom?-->
        </v-card-text>

        <v-card-text class="py-0 ">
          <v-chip
            v-for="label in labels" :key="label"
            label small disabled
            color="link lighten-5"
            class="mr-2 px-2 mt-2 liiblack--text tool-tags" >
              {{ label }} 
          </v-chip>
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
</template>


<script>  
  export default {
    name:'hklii-hometool',
    props:{
        title: String,
        content: String,
        thumbnail: String,
        addr: String,
        labels: Array,
        gradientStyle: String,
    },
  }
</script>


<style scoped lang="scss">
  h4 {
    line-break: auto;  /*for CKJ*/
    word-break: normal;
  }

  p {
    font-size: 10pt;
    line-height: 12.5pt;
    line-break: auto;  /*for CKJ*/
    word-break: normal;
  }

  .tool-title{
    align-items: top;
  }

  .tool-preview ::v-deep .v-image__image {
    background-position: center top !important;
  }

  .v-chip--disabled {
    opacity:1 !important;
  }
</style>